import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PurgeState } from '../_reducers/purge.reducers';

const getPurgeFeatureState = createFeatureSelector<PurgeState>('purge');

/**
 * Select purges by table
 */
export const getPurges = createSelector(
    getPurgeFeatureState,
  (state: PurgeState) => state.purge
);

/**
 * Select operations
 */
export const getPurgeOperations = createSelector(
    getPurgeFeatureState,
  (state: PurgeState) => state.operations
);

/**
 * Select error
 */
export const getPurgeError = createSelector(
    getPurgeFeatureState,
  (state: PurgeState) => state.error
);
